import { mdiCircleMedium } from '@mdi/js'

const themeConfig = {
  app: {
    name: 'انار گیفت',
    logo: require('@/assets/images/apple-icon.png'),
    isDark: false,
    isRtl: true,
    contentLayoutNav: localStorage.getItem('materio-active-layout')
      ? localStorage.getItem('materio-active-layout')
      : 'vertical', // vertical, horizontal
    routeTransition: 'slide-x-transition', // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: 'default', // default, bordered, semi-dark
    contentWidth: 'boxed', // full-width, boxed
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCircleMedium,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: 'fixed', // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: 'static', // fixed, static, hidden
  },
  themes: {
    light: {
      primary: '#f44336',
      accent: '#ebeeeb',
      secondary: '#d0d1d4',
      success: '#56ca00',
      info: '#16b1ff',
      warning: '#FFB400',
      error: '#FF4C51',
    },
    dark: {
      primary: '#f44336',
      accent: '#ebeeeb',
      secondary: '#8A8D93',
      success: '#56CA00',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#FF4C51',
    },
  },
}

export default themeConfig
